import React, { useState } from 'react';

function SurveyStepThirtyOne({ formData, onNext }) {
    const [feedbackQuality, setFeedbackQuality] = useState(formData.feedbackQuality || '');
    const [feedbackComments, setFeedbackComments] = useState(formData.feedbackComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!feedbackQuality) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ feedbackQuality, feedbackComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 7: Leadership & Management</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How actionable and constructive is the feedback you receive from your managers? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`feedback-quality-${option}`}
                            name="feedbackQuality"
                            value={option}
                            checked={feedbackQuality === option}
                            onChange={() => setFeedbackQuality(option)}
                        />
                        <label htmlFor={`feedback-quality-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={feedbackComments}
                    onChange={(e) => setFeedbackComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!feedbackQuality}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirtyOne;
